import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Flex, Box, Button, Copy, Icon, Currency } from '@elparking/components'

import { Container, Files } from '../../ui'

import DateTime from 'commons/js/ui/DateTime'
import Field from './Field'
import Conversation from './Conversation'
import ClaimStatus from './ClaimStatus'
import { LOCALE_DATETIME_FORMAT, TIMEZONE_FORMAT } from 'commons/js/constants'
import { SOPPORTED_CLAIMS_STATUS } from '../../api/constants'

const Detail = ({ fine, goToClaim, onBack, goToPay }) => {
    return (
        <Container key='detail' width='600px'>
            <Box w='50%' mb='1em'>
                <Button.unstyled onClick={onBack}>
                    <Copy fontColor='main' transform='uppercase'>
                        <Icon type='left' /> <FormattedMessage defaultMessage='Volver a buscar' />
                    </Copy>
                </Button.unstyled>
            </Box>
            <Flex flexWrap='wrap' justifyContent='space-between'>
                <Box w='100%' flex='1' pr={['0', '0.5em']} >
                    <Copy fontWeight='book' fontSize='xxxSmall' color='gray60' transform='uppercase' padding='0'>
                        <FormattedMessage defaultMessage='Número de boletín' />
                    </Copy>
                    <Copy fontSize='large' fontWeight='book' padding='0'>
                        {fine.bulletinNumber}
                    </Copy>
                </Box>
                <Box w='100%' flex='1' pl={['0', '0.5em']} textAlign='right'>
                    <Copy fontWeight='book' fontSize='xxxSmall' color='gray60' transform='uppercase' padding='0'>
                        <FormattedMessage defaultMessage='Estado' />
                    </Copy>
                    <Copy fontSize='large' fontWeight='book' padding='0' color={fine.isCancelled ? 'green' : 'gray'}>
                        { fine.isCancelled
                        ? <FormattedMessage defaultMessage='Anulada' />
                        : <FormattedMessage defaultMessage='No anulada' />
                        }
                    </Copy>
                </Box>
            </Flex>
            <Copy color='gray60' fontSize='xxxSmall' fontWeight='medium' transform='uppercase' mt='2em'>
                <FormattedMessage defaultMessage='Tipo de infracción' />
            </Copy>
            <Box background='lightGray20' p='0.5em' >
                <Copy color='gray' fontWeight='regular'>
                    {fine.reason}
                </Copy>
            </Box>
            <Flex flexWrap='wrap'>
                <Box w={['100%', '100%', '50%']} pr={['0', '0.5em']} >
                    <Field
                      label={<FormattedMessage defaultMessage='Denuncia completa' />}
                      value={<Currency qty={fine.originalQty} />}
                    />
                </Box><Box pl={['0', '0.5em']} w={['100%', '100%', '50%']}>
                    <Field
                      label={<FormattedMessage defaultMessage='Total a pagar' />}
                      value={<Currency qty={fine.fareQty} />}
                    />
                </Box>
            </Flex>
            <Flex flexWrap='wrap'>
                <Box w={['100%', '100%', '50%']} pr={['0', '0.5em']} >
                    <Field
                      icon='calendar-empty'
                      label={<FormattedMessage defaultMessage='Fecha' />}
                      value={
                          <>
                              <DateTime value={fine.date} format={LOCALE_DATETIME_FORMAT} timeZone={fine.parkingTimeZone} />
                              {' '}
                              (<DateTime value={fine.date} format={TIMEZONE_FORMAT} timeZone={fine.parkingTimeZone} />)
                          </>
                      }
                    />
                </Box><Box pl={['0', '0.5em']} w={['100%', '100%', '50%']}>
                    <Field
                      icon={fine.dueDate ? 'calendar-empty' : null}
                      label={<FormattedMessage defaultMessage='Fecha límite' />}
                      value={fine.dueDate
                        ? <>
                            <DateTime value={fine.dueDate} format={LOCALE_DATETIME_FORMAT} timeZone={fine.parkingTimeZone} />
                            {' '}
                            (<DateTime value={fine.dueDate} format={TIMEZONE_FORMAT} timeZone={fine.parkingTimeZone} />)
                        </>
                        : <Copy fontWeight='regular' fontColor='lightGray' padding='0'>{' - - -'}</Copy>
                      }
                    />
                </Box>
            </Flex>
            <Flex flexWrap='wrap'>
                { fine.dateReducedAmount && <Box w={['100%', '100%', '50%']} pr={['0', '0.5em']} >
                    <Field
                      icon='calendar-empty'
                      label={<FormattedMessage defaultMessage='Fecha máxima para descuento' />}
                      value={
                          <>
                              <DateTime value={fine.dateReducedAmount} format={LOCALE_DATETIME_FORMAT} timeZone={fine.parkingTimeZone} />
                              {' '}
                              (<DateTime value={fine.dateReducedAmount} format={TIMEZONE_FORMAT} timeZone={fine.parkingTimeZone} />)
                          </>
                      }
                    />
                </Box>}
                <Box pl={['0', '0.5em']} w={['100%', '100%', fine.dateReducedAmount ? '50%' : '100%']}>
                    <Field
                      label={<FormattedMessage defaultMessage='Localización' />}
                      value={fine.parkingName}
                    />
                </Box>
            </Flex>
            <Flex flexWrap='wrap'>
                <Box w={['100%', '100%', '50%']} pr={['0', '0.5em']} >
                    <Field
                      icon='car'
                      label={<FormattedMessage defaultMessage='Vehículo' />}
                      value={fine.vehicle}
                    />
                </Box><Box pl={['0', '0.5em']} w={['100%', '100%', '50%']}>
                    <Field
                      label={<FormattedMessage defaultMessage='Matrícula' />}
                      value={fine.numberPlate}
                    />
                </Box>
            </Flex>
            { fine.files && <Flex flexWrap='wrap' mt='1em'>
                <Files bulletinNumber={fine.bulletinNumber} files={fine.files} />
            </Flex> }
            <Flex flexWrap='wrap'>
                <Box mt='1em' width={['100%', '100%', '50%']} pr={['0', '0.5em']}>
                    <Button width='100%' backgroundColor='accent' onClick={goToPay} disabled={fine.isCancelled}>
                        <Icon type='wallet' color='white' /> <FormattedMessage defaultMessage='Pagar denuncia' />
                    </Button>
                </Box>
                <Box mt='1em' width={['100%', '100%', '50%']} pl={['0', '0.5em']} textAlign='right'>
                    <Button width='100%' onClick={goToClaim} disabled={fine.isCancelled}>
                        <FormattedMessage defaultMessage='Apelar denuncia' /> <Icon color='white' type='right' />
                    </Button>
                </Box>
            </Flex>
            {SOPPORTED_CLAIMS_STATUS.includes(fine.lastFeedbackStatus) && <Box mt='2em' textAlign='right'>
                <Copy fontWeight='book' fontSize='xxxSmall' color='gray60' transform='uppercase' padding='0'>
                    <FormattedMessage defaultMessage='Estado de la última reclamación' />
                </Copy>
                <Copy fontWeight='medium' fontSize='xxxSmall' color='gray' transform='uppercase' padding='0'>
                    <ClaimStatus status={fine.lastFeedbackStatus} />
                </Copy>
            </Box>}
            <Box>
                { !!fine.claims.length && <Conversation fine={fine} /> }
            </Box>
        </Container>
    )
}

Detail.propTypes = {
    onBack: PropTypes.func,
    goToClaim: PropTypes.func,
    goToPay: PropTypes.func,
    fine: PropTypes.shape({
        claims: PropTypes.array,
        vehicle: PropTypes.string,
        files: PropTypes.array,
        numberPlate: PropTypes.string,
        parkingName: PropTypes.string,
        parkingTimeZone: PropTypes.string,
        bulletinNumber: PropTypes.string,
        reason: PropTypes.string,
        date: PropTypes.number,
        dueDate: PropTypes.number,
        dateReducedAmount: PropTypes.number,
        fareQty: PropTypes.object,
        originalQty: PropTypes.object,
        isCancelled: PropTypes.bool,
        lastFeedbackStatus: PropTypes.number,
    }).isRequired,
}

Detail.defaultProps = {
    onBack: () => {},
    goToClaim: () => {},
    goToPay: () => {},
}

export default Detail
